// ./src/config/driveTypes.ts
// Drive type configuration for vehicles
// Used by car forms, selectors, and display helpers

// ============================================
// Types
// ============================================

export interface DriveTypeOption {
  /** Value stored in database */
  value: string;
  /** Translation key for full label - use with t('common:driveTypes.fwd') */
  labelKey: string;
  /** Translation key for short label - use with t('common:driveTypes.fwdShort') */
  labelShortKey: string;
  /** Icon name for UI components */
  iconName: string;
}

// ============================================
// Drive Type Options
// ============================================

export const DRIVE_TYPE_OPTIONS: DriveTypeOption[] = [
  { value: "fwd", labelKey: "driveTypes.fwd", labelShortKey: "driveTypes.fwdShort", iconName: "Car" },
  { value: "rwd", labelKey: "driveTypes.rwd", labelShortKey: "driveTypes.rwdShort", iconName: "Car" },
  { value: "awd", labelKey: "driveTypes.awd", labelShortKey: "driveTypes.awdShort", iconName: "Car" },
  { value: "4wd", labelKey: "driveTypes.4wd", labelShortKey: "driveTypes.4wdShort", iconName: "Truck" },
  { value: "4x4", labelKey: "driveTypes.4x4", labelShortKey: "driveTypes.4x4Short", iconName: "Truck" },
];

// ============================================
// Lookup Map
// ============================================

export const DRIVE_TYPE_MAP: Record<string, DriveTypeOption> = Object.fromEntries(
  DRIVE_TYPE_OPTIONS.map((opt) => [opt.value, opt])
);

// ============================================
// Helper Functions
// ============================================

/**
 * Get drive type option by value
 * @param value - Drive type value
 * @returns Drive type option or undefined
 */
export const getDriveTypeOption = (
  value: string | null | undefined
): DriveTypeOption | undefined => {
  if (!value) return undefined;
  return DRIVE_TYPE_MAP[value];
};

/**
 * Get icon name for a drive type
 * @param value - Drive type value
 * @returns Icon name or default
 */
export const getDriveTypeIcon = (value: string | null | undefined): string => {
  return getDriveTypeOption(value)?.iconName ?? "Car";
};